export const PERSISTED_VERTICAL_FILTERS_KEY = 'persistedVerticalFilters';
export const DISTRICT_ON = 'currentDistrictIdentifier';
